import { render, staticRenderFns } from "./PopoverRosterProgram.vue?vue&type=template&id=2c1f4d09&scoped=true"
import script from "./PopoverRosterProgram.vue?vue&type=script&lang=js"
export * from "./PopoverRosterProgram.vue?vue&type=script&lang=js"
import style0 from "./PopoverRosterProgram.vue?vue&type=style&index=0&id=2c1f4d09&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1f4d09",
  null
  
)

export default component.exports